module.exports = __webpack_public_path__ + "static/media/letter-3.a6ba7a71.png";